export enum MerchantSetupProduct {
  Disputes = "disputes",
  Shopperagent = "shopperAgent",
  Marketing = "marketing",
}
